async function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

interface RetryOptions {
  ms: number;
  retries: number;
}

/**
 * Tries to get a value from a getter function. If it fails, it will retry.
 *
 * @param getter Getter function.
 * @param options.ms Milliseconds to wait between retries.
 * @param options.retries Number of retries.
 * @returns Value from getter function.
 */
export async function retryValue<T>(getter: () => T, options: RetryOptions): Promise<T | undefined> {
  let toBreak = false;
  let tries = options.retries;

  let temp: T | undefined;

  while (tries !== 0) {
    try {
      temp = getter();
      if (temp !== undefined) {
        toBreak = true;
      }
    } catch (err) {
      tries--;
      if (!tries) {
        toBreak = true;
      }
    } finally {
      if (toBreak) {
        break;
      } else {
        tries--;
      }
    }
    await sleep(options.ms);
  }

  return temp;
}
